
import { useRef, useState } from "react";
import { hookDebugUtils } from "@/utils/ai/debugUtils";

/**
 * Hook for debug utilities
 */
export const useDebugHookUtils = (hookName: string) => {
  // Debugging instance ID
  const instanceId = useRef(`${hookName}_${Math.random().toString(36).substr(2, 9)}`);
  const hookMountTime = useRef(new Date().toISOString());
  
  // Register hook for debugging
  useState(() => {
    hookDebugUtils.registerHook(hookName, instanceId.current);
    console.log(`${hookName} ${instanceId.current} initialized at ${hookMountTime.current}`);
    
    return () => {
      hookDebugUtils.unregisterHook(hookName);
    };
  });
  
  return {
    instanceId,
    hookMountTime
  };
};
